<div [formGroup]="parentForm" class="input-select">
  <a class="clear-selection" (click)="onClear()" *ngIf="showClear && allowClear"><i class="far fa-times"></i></a>
  <mat-select [formControlName]="controlName" [placeholder]="inputPlaceholder" [panelClass]="panelClass"
    (selectionChange)="onValueChanged.emit($event.value)" [hideSingleSelectionIndicator]="true">
    <input class="search-input" [disabled]="disabled" matInput #searchInput (keyup)="onSearchInputChanged()"
      [placeholder]="searchInputPlaceholder" *ngIf="allowFiltering">
    <mat-option *ngFor="let item of items" [value]="item.value">{{item.text}}</mat-option>
  </mat-select>
</div>